<template lang="pug">
BriqTable
  tr
    th
    th(:class="`${isSortable('ResourceName')}`" id="ResourceName" @click="sortBy($event)") Resource
    th(:class="`${isSortable('ProductQuantity')}`" id="ProductQuantity" @click="sortBy($event)") Quantity
    th(:class="`${isSortable('FromDateTime')}`" id="FromDateTime" @click="sortBy($event)") Start
    th(:class="`${isSortable('ToDateTime')}`" id="ToDateTime" @click="sortBy($event)") End
    th(:class="`${isSortable('Exclusivity')}`" id="Exclusivity" @click="sortBy($event)") Exclusive
    th(:class="`${segmentSortable} ${isSortable('SegmentAvatar.Name')}`" id='SegmentAvatar.Name' @click="sortBy($event)") Segment
  tr(v-if="plannedCheckinTime")
    td Check-in
    td -
    td -
    td {{ getTime(plannedCheckinTime) }}
    td -
    td -
    td -
  tr(v-for="(bp, i) in orderedBookingProducts" :key="`booking-product-${i}`")
    td
      WarningLabel(
        v-if="bp.ProductActiveState !== 'Active'"
        :label="bp.ProductName"
        :status="bp.ProductActiveState"
        )
      div(v-else) {{ bp.ProductName }} 
    td.flex.align-center
      span.resource-abbreviation(
        :title="bp.ResourceName"
        :style="`background-color: ${bp.ResourceColor};`"
        ) {{ resourceAbbreviation(bp)  }} 
      span {{ bp.ResourceName }}
    td {{ bp.ProductQuantity }}
    td {{ getTime(bp.FromDateTime) }}
    td {{ getTime(bp.ToDateTime) }}
    td {{ bp.Exclusivity != 'None' ? bp.Exclusivity : '-' }}
    td {{ getSegmentName(bp) }}
</template>

<script>
import { formatTimeFromUtc } from '@/helpers/dateTimeFormatter.js'
import { sortBy, prop } from 'ramda'
import WarningLabel from '@v/components/WarningLabel.vue'

export default {
  name: 'BookingScheduleTable',
  components: { WarningLabel },
  props: {
    plannedCheckinTime: String,
    scheduledBookingProducts: Array,
  },
  data() {
    return {
      filter: 'FromDateTime',
      filterLowHigh: true,
    }
  },
  computed: {
    orderedBookingProducts() {
      if (this.filterLowHigh) return this.sortedProducts(this.scheduledBookingProducts)
      if (!this.filterLowHigh) return this.sortedProducts(this.scheduledBookingProducts).reverse()
    },
    applyFilters() {
      return this.orderedBookingProducts?.length > 1
    },
    segmentSortable() {
      return this.checkVariations(
        this.scheduledBookingProducts.map(bp => bp.SegmentAvatar?.Name),
      ) && this.applyFilters
        ? 'sortable'
        : ''
    },
    filterDirection() {
      if (this.filterLowHigh) return 'up'
      if (!this.filterLowHigh) return 'down'
    },
  },
  methods: {
    getTime(dateTimeUtc) {
      return formatTimeFromUtc(this.$locale)(this.$timezone)(dateTimeUtc)
    },
    resourceAbbreviation(bp) {
      return bp.ResourceAbbreviation
        ? bp.ResourceAbbreviation.toUpperCase()
        : bp.ResourceName.substring(0, 2).toUpperCase()
    },
    getSegmentName(bp) {
      if (!bp.SegmentAvatar) return '-'
      return bp.SegmentAvatar.IsConflicted ? 'x' : bp.SegmentAvatar.Name
      // IsConflicted means this booking product contains segments that are not allowed to go together
    },
    sortBy(event) {
      const filter = event.target.id
      const classList = event.target.classList
      if (!classList.contains('sortable')) return
      if (!filter || !this.applyFilters) return
      if (this.filter === filter) {
        this.filterLowHigh = !this.filterLowHigh
      } else {
        this.filterLowHigh = true
        this.filter = filter
      }
    },
    sortedProducts(products) {
      return sortBy(prop(this.filter))(products)
    },
    checkVariations(arr) {
      const hasVariations = arr.every(value => value === arr[0])
      return !hasVariations
    },
    isSortable(id) {
      if (!this.applyFilters) return ''

      let classes = []
      const sortable = this.checkVariations(this.scheduledBookingProducts.map(bp => bp[id]))
      if (sortable) classes.push('sortable')
      if (sortable && this.filter === id) {
        classes.push('active')
        if (this.filterLowHigh) classes.push('down')
        if (!this.filterLowHigh) classes.push('up')
      }

      return classes.join(' ')
    },
  },
}
</script>

<style scoped lang="stylus">
.resource-abbreviation
  background-color gray
  width 17px
  height 17px
  border-radius 3px
  font-size 9px
  line-height 1
  display inline-flex
  justify-content center
  align-items center
  margin-right 3px
  color #fff
  font-weight 700

.sortable
  position: relative
.sortable:hover
  cursor: pointer
  text-decoration: underline


.sortable::after
  position: absolute
  top: 6px
  right: 6px
  content: url('../../../../../assets/icons/sort_both.png')

.active.up::after
  top: 2px
  content: url('../../../../../assets/icons/sort_asc.png')

.active.down::after
  top: 2px
  content: url('../../../../../assets/icons/sort_desc.png')
</style>
